// Chaînes transverses du parcours donateur (boutons, erreurs génériques).
// Clés préfixées "common." — voir i18n/index.js pour la convention.
const common = {
  fr: {
    "common.loading": "Chargement…",
    "common.error": "Une erreur est survenue. Réessayez.",
    "common.cancel": "Annuler",
    "common.confirm": "Confirmer",
    "common.back": "Retour",
    "common.next": "Continuer",
    "common.close": "Fermer",
    "common.optional": "facultatif",
    "common.required_fields": "Champs obligatoires",
    "common.email": "Email",
    "common.phone": "Téléphone",
    "common.first_name": "Prénom",
    "common.last_name": "Nom",
    "common.address": "Adresse",
    "common.postal_code": "Code postal",
    "common.city": "Ville",
    "common.country": "Pays",
    "common.company_name": "Nom de l'entreprise",
    "common.siren": "SIREN (facultatif)",
    "common.individual": "Particulier",
    "common.company": "Entreprise",
    "common.amount": "Montant",
    "common.date": "Date",
    "common.send": "Envoyer",
    "common.retry": "Réessayer",
    // Limite d'erreur de l'application (morceau de code non chargé, plantage)
    "common.load_failed_title": "La page n'a pas pu se charger",
    "common.load_failed_body": "La connexion a peut-être été interrompue, ou une nouvelle version du site vient d'être mise en ligne. Rechargez la page pour continuer.",
    "common.crash_title": "Un problème est survenu",
    "common.crash_body": "Cette page n'a pas pu s'afficher. Rechargez-la pour continuer.",
    "common.reload": "Recharger",
  },
  en: {
    "common.loading": "Loading…",
    "common.error": "Something went wrong. Please try again.",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.next": "Continue",
    "common.close": "Close",
    "common.optional": "optional",
    "common.required_fields": "Required fields",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.first_name": "First name",
    "common.last_name": "Last name",
    "common.address": "Address",
    "common.postal_code": "Postal code",
    "common.city": "City",
    "common.country": "Country",
    "common.company_name": "Company name",
    "common.siren": "SIREN (optional)",
    "common.individual": "Individual",
    "common.company": "Company",
    "common.amount": "Amount",
    "common.date": "Date",
    "common.send": "Send",
    "common.retry": "Try again",
    "common.load_failed_title": "This page could not load",
    "common.load_failed_body": "Your connection may have dropped, or a new version of the site has just been released. Reload the page to continue.",
    "common.crash_title": "Something went wrong",
    "common.crash_body": "This page could not be displayed. Reload it to continue.",
    "common.reload": "Reload",
  },
};

export default common;
